module.exports = __webpack_public_path__ + "media/modules/layout/zwar-logo-red_de-cf8f3fc22eef1ef1e2fbbd02ddf9d1b0.png";